function toBoolean(value) {
  if (typeof value === "boolean") return value;
  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();
    if (["1", "true", "yes", "sim", "on"].includes(normalized)) return true;
    if (["0", "false", "no", "nao", "não", "off", ""].includes(normalized)) return false;
  }
  return Boolean(value);
}

export function canManageBlogPosts(user) {
  if (!user) return false;

  const flags = [
    user?.can_manage_blog_posts,
    user?.canManageBlogPosts,
    user?.user?.can_manage_blog_posts,
    user?.user?.canManageBlogPosts,
  ];

  for (const flag of flags) {
    if (flag !== undefined && flag !== null && flag !== "") {
      return toBoolean(flag);
    }
  }

  return Boolean(user?.is_superuser || user?.user?.is_superuser);
}
